import dateFormat from 'dateformat';
import { getDateTimeFormat } from '#helper';

export default function momentFormat(date, account, formatType) {
  const d = new Date(date);
  const interval = new Date() - d;
  const min = 1000 * 60;

  return interval < min * 2 ? 'a minute ago' :
    interval < min * 58 ?
      `${Math.round(interval / min)} minutes ago` :
      interval < min * 65 ?
        'an hour ago' :
        dateFormat(date, getDateTimeFormat(account && account.measurementSystem, formatType));
}
